import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { Status } from 'src/app/models/statusEnums';
import { AppMainComponent } from '../../../../app.main.component';
import { TypeGroupIds } from '../../../../modules/shared/constants/category-groupid.constants';
import { ObjectNames } from '../../../../shared/constants';
import { CrmAccountFieldService } from './fields.service';
import { Answer } from '../../constants/constants';
import { AccountService } from 'src/app/accounts/accountService';
import { AddEditAddressModalService } from 'src/app/modules/shared/components/address/address-add-update-modal/address-add-update-modal.service';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntil, tap } from 'rxjs/operators';
import { catchError, of, Subject } from 'rxjs';
import { OrganizationSubscriptionService } from 'src/app/modules/shared/services/organization-subscription.service';
import { SubscriptionFeatureLimitM } from 'src/app/modules/shared/models/organization-subscription/subscription-feature-limit.modal';
import { FeatureSubscriptionInfoEnums } from 'src/app/modules/shared/enums/feature-subscription-info.enum';

@Component({
  selector: 'app-account-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.scss'],
  providers: [ConfirmationService, CrmAccountFieldService]
})
export class CrmAccountFieldsComponent implements OnInit, OnChanges, OnDestroy {

   protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() addNewField: any;
  @Input() accountFieldConfig = [];

  @Output() reLoadConfigurations = new EventEmitter();

  objectId = 1;

  accountType = [];
  accountSource = [];
  ratings = [];
  timeZoneList = [];
  currencies = [];
  employeesCounts = [];
  revenue = [];
  ownerships = [];
  industries = [];
  accountEmail = [];
  accountPhone = [];
  accountSocial = [];
  currrentAccountFieldConfig = [];
  emailConfigAccount;
  phoneConfigAccount;
  socialConfigAccount;
  configTemp;
  copiedList = [];

  // field data popup
  selectedAccountDataType;
  accountDataTemp;
  displayAddAccountData = false;
  formSubmitted = false;
  addEditAccountHeader;
  invalidData = false;

  answertypeConstants = Answer;
  activeId: number;
  inactiveId: number;
  activeReason: Array<any> = [];
  inactiveReason: Array<any> = [];
  addressTypes = [];
  addressClasses = [];

  accountDataTypes = [
    { id: 0, name: "Account Type", code: "account type" },
    { id: 1, name: "Account Source", code: "account source" },
    { id: 2, name: "Rating", code: "rating" },
    { id: 3, name: "Timezone", code: "timezone" },
    { id: 4, name: "Number of Employees", code: "employees count" },
    { id: 5, name: "Estimated Annual Revenue", code: "revenue" },
    { id: 6, name: "Ownership Type", code: "ownership type" },
    { id: 7, name: "Industry", code: "industry" },
    { id: 8, name: "Account Email", code: "account email" },
    { id: 9, name: "Account Phone", code: "account phone" },
    { id: 10, name: "Account Social", code: "account social" },
    { id: 11, name: "Active Reason", code: "AccountActivatedReason" },
    { id: 12, name: "Inactive Reason", code: "AccountInactivatedReason" },
    { id: 13, name: "Address Type", code: "address type" },
    { id: 14, name: "Address Class", code: "address class" },
    { id: 15, name: "Tags", code: "tags" },
    // { id: 15, name: "Currency", code: "currency" },
  ];
  accountTypeId = 0;

  fieldTranslate = {
    AddFieldDataHeader: "",
    EditFieldDataHeader: "",
    DeleteConfirmationHeader: "",
    AccountTypeDeleteConfMsg: "",
    AccountScourceDeleteConfMsg: "",
    RatingDeleteConfMsg: "",
    TimezoneDeleteConfMsg: "",
    NumOfEmployeeDeleteConfMsg: "",
    EstimatedAnnualRevenueDeleteConfMsg: "",
    OwnershipTypeDeleteConfMsg: "",
    IndustryDeleteConfMsg: "",
    AccountEmailDeleteConfMsg: "",
    AccountPhoneDeleteConfMsg: "",
    AccountSocialProfileDeleteConfMsg: ""
  };

  showAddFieldDataArea: boolean = false;
  showEditFieldDataArea: boolean = false;
  showActiveBtn: boolean = false;

  //tags
  tags = [
    {id:1,value:"Success",color:"#3B82F6",isActive:true},
    {id:2,value:"Info",color:"#22C55E",isActive:true},
    {id:3,value:"Warning",color:"#F59E0B",isActive:true},
    {id:4,value:"Danger",color:"#EF4444",isActive:true},
  ]
  tagList:any[] = [];
  displayEditTag:boolean = false;
  tempTag:any = {id:0,name:"",color:"#000000",statusId:0,isActive:false};

  subscriptionLimit: SubscriptionFeatureLimitM = null;

  constructor(
    private app: AppMainComponent,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private service: ConfigurationService,
    private appMainService: AppMainService,
    private fieldService: CrmAccountFieldService,
    private translocoService: TranslocoService,
    private accountService: AccountService,
    private addEditAddressModalService: AddEditAddressModalService,
    private organizationSubscriptionService: OrganizationSubscriptionService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.addNewField && changes.addNewField.currentValue) {
      const newRecordObj = changes.addNewField.currentValue;
      if (newRecordObj.name == 'Field') {
        this.showNewField();
      }
    }

    if (changes.accountFieldConfig && changes.accountFieldConfig.currentValue) {
      this.currrentAccountFieldConfig = changes.accountFieldConfig.currentValue;
      this.emailConfigAccount = this.currrentAccountFieldConfig.find(obj => obj.name == ObjectNames.ACCOUNT_EMAIL_TYPES);
      this.accountEmail = this.emailConfigAccount != null ? JSON.parse(this.emailConfigAccount.configurationDetails && this.emailConfigAccount.configurationDetails[0].configJSONValue) : [];

      this.phoneConfigAccount = this.currrentAccountFieldConfig.find(obj => obj.name == ObjectNames.ACCOUNT_PHONE_TYPES);
      this.accountPhone = this.phoneConfigAccount != null ? JSON.parse(this.phoneConfigAccount.configurationDetails && this.phoneConfigAccount.configurationDetails[0].configJSONValue) : [];

      this.socialConfigAccount = this.currrentAccountFieldConfig.find(obj => obj.name == ObjectNames.ACCOUNT_SOCIAL_TYPES);
      this.accountSocial = this.socialConfigAccount != null ? JSON.parse(this.socialConfigAccount.configurationDetails && this.socialConfigAccount.configurationDetails[0].configJSONValue) : [];
    }
  }

  ngOnInit(): void {
    this.reLoadConfigurations.emit();
    this.checkSubscriptionLimit();
    this.getTranslatedValue();
    this.loadAccountSources();
    this.loadRatings();
    this.loadTimeZoneList();
    this.loadCurrencies();
    this.loadEmployeeCountList();
    this.loadRevenuList();
    this.loadOwnerShipList();
    this.loadIndustries();
    this.getActiveInactiveReason('AccountActivatedReason');
    this.getActiveInactiveReason('AccountInactivatedReason');
    this.loadAddressTypes();
    this.loadAddressClasses();
    this.loadAccountTypes();
    this.loadTages();
  }

    checkSubscriptionLimit() {
        this.organizationSubscriptionService
            .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Tags)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.subscriptionLimit = response;
                }
            })
    }

    get subscriptionLimitReached(){
        return ((this.selectedAccountDataType?.id == 15)
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }


  getTranslatedValue() {
    this.translocoService.selectTranslate('Configuration.CRM.Add_Field_Data').subscribe((data) => {
      this.fieldTranslate.AddFieldDataHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Edit_Field_Data').subscribe((data) => {
      this.fieldTranslate.EditFieldDataHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Delete_Confirmation').subscribe((data) => {
      this.fieldTranslate.DeleteConfirmationHeader = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Account_Type_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.AccountTypeDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Account_Source_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.AccountScourceDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Rating_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.RatingDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Timezone_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.TimezoneDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Number_of_Employees_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.NumOfEmployeeDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Estimated_Annual_Revenue_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.EstimatedAnnualRevenueDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Ownership_Type_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.OwnershipTypeDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Industry_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.IndustryDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Account_Email_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.AccountEmailDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Account_Phone_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.AccountPhoneDeleteConfMsg = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Account_Social_Profile_Delete_Conf_MSG').subscribe((data) => {
      this.fieldTranslate.AccountSocialProfileDeleteConfMsg = data;
    });
  }

  loadAccountTypes() {
    this.fieldService.getAllAccountTypes(TypeGroupIds.AccountTypeAccountAPI).subscribe(
      types => {
        this.accountType = types || [];
        this.accountType.sort((a, b) => a.name.localeCompare(b.name));
        this.copiedList = JSON.parse(JSON.stringify(this.accountType));
      });
  }

  loadAccountSources(fromAdd?) {
    this.fieldService.getAllSources(this.app.user.organizationId).subscribe(sources => {
      this.accountSource = sources || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.accountSource));
      }
    });
  }

  loadRatings(fromAdd?) {
    this.fieldService.getAllRatings().subscribe(ratings => {
      this.ratings = ratings || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.accountSource));
      }
    });
  }

  loadTimeZoneList(fromAdd?) {
    this.fieldService.getTimezone().subscribe(timezoneList => {
      this.timeZoneList = timezoneList || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.timeZoneList));
      }
    });
  }

  loadCurrencies(fromAdd?) {
    this.fieldService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.accountSource));
      }
    });
  }

  loadEmployeeCountList(fromAdd?) {
    this.fieldService.getAllEmployeesCount().subscribe(count => {
      this.employeesCounts = count || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.employeesCounts));
      }
    });
  }

  loadRevenuList(fromAdd?) {
    this.fieldService.getAllRevenues().subscribe(revenue => {
      this.revenue = revenue || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.revenue));
      }
    });
  }

  loadOwnerShipList(fromAdd?) {
    this.fieldService.getAllOwnerships().subscribe(owners => {
      this.ownerships = owners || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.ownerships));
      }
    });
  }

  loadIndustries(fromAdd?) {
    this.fieldService.getAllIndustries().subscribe(industries => {
      this.industries = industries || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.accountSource));
      }
    });
  }

  loadAddressTypes(fromAdd?) {
    this.addEditAddressModalService.getAccountAddressTypes().subscribe(res => {
      this.addressTypes = res || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.addressTypes));
      }
    });
  }

  loadAddressClasses(fromAdd?) {
    this.addEditAddressModalService.getAccountAddressClasses().subscribe(res => {
      this.addressClasses = res || [];

      if (fromAdd) {
        this.copiedList = JSON.parse(JSON.stringify(this.addressClasses));
      }
    });
  }

  showNewField() {
    this.selectedAccountDataType = null;
    this.accountDataTemp = {
      "name": "",
      "description": "",
      "id": 0,
      "code": "",
      "color": "#000000",
      "checked": false
    }
    this.displayAddAccountData = true;
    this.formSubmitted = false;
    this.addEditAccountHeader = this.fieldTranslate.AddFieldDataHeader;
    this.invalidData = false;
    this.showAddFieldDataArea = true;
    this.showEditFieldDataArea = false;
  }

  getAccountDataType() {
    if (this.selectedAccountDataType ? this.selectedAccountDataType.code == 'account email' : null
      || this.selectedAccountDataType ? this.selectedAccountDataType.code == 'account phone' : null
        || this.selectedAccountDataType ? this.selectedAccountDataType.code == 'account social' : null) {
      this.accountDataTemp = {
        "name": "",
        "description": "",
        "id": 0,
        "code": "",
        "checked": false
      }
    } else if (this.selectedAccountDataType ? this.selectedAccountDataType.code == 'account type' : null) {
      this.accountDataTemp = {
        "id": 0,
        "createdSource": this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.user.userId,
        "updatedBy": this.app.user.organizationId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "name": "",
        "parentTypeId": 0,
        "description": "",
        "groupId": this.objectId,
        "objectId": this.objectId,
        "objectRecordId": 1,
        "group": null,
        "statusId": 1,
        "isDefault": false,
        "status": null,
        "organizationId": this.app.user.organizationId,
        "colorCodeId": null
      }
    } else {
      this.accountDataTemp = {
        "id": 0,
        "createdSource": this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.user.userId,
        "updatedBy": this.app.user.organizationId,
        "createdDate": new Date().toISOString(),
        "updatedDate": new Date().toISOString(),
        "name": "",
        "color": "#000000",
        "description": "",
        "statusId": 1,
        "organizationId": this.app.user.organizationId,
      }
    }
  }

  saveAccountDataAdd() {
    if (this.checkValidationForFieldData()) {
      this.formSubmitted = true;
    }
    else {
      this.formSubmitted = false;
      if (this.showAddFieldDataArea) {
        if (this.selectedAccountDataType.code == 'account type') {
          let lowerAccountNames = [];
          for (let s of this.accountType) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.trim()) > -1) {
            this.invalidData = true;
          }
          else {
            this.service.addAccountType(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadAccountTypes()
              this.displayAddAccountData = false;
              this.formSubmitted = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'account source') {
          let lowerAccountNames = [];
          for (let s of this.accountSource) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addAccountSource(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadAccountSources(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'rating') {
          let lowerAccountNames = [];
          for (let s of this.ratings) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addRating(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadRatings(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'timezone') {
          let lowerAccountNames = [];
          for (let s of this.timeZoneList) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addTimezone(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadTimeZoneList(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'employees count') {
          let lowerAccountNames = [];
          for (let s of this.employeesCounts) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addEmployeesNo(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadEmployeeCountList(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'revenue') {
          let lowerAccountNames = [];
          for (let s of this.revenue) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addRevenue(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadRevenuList(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'ownership type') {
          let lowerAccountNames = [];
          for (let s of this.ownerships) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addOwnership(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadOwnerShipList(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'industry') {
          let lowerAccountNames = [];
          for (let s of this.industries) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.service.addIndustry(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadIndustries(true);
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'account email') {
          let lowerAccountNames = [];
          for (let s of this.accountEmail) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.configTemp = {
              "id": this.emailConfigAccount.id,
              "createdSource": this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              "updatedBy": this.app.user.organizationId,
              "createdDate": new Date().toISOString(),
              "updatedDate": new Date().toISOString(),
              "organizationId": this.emailConfigAccount.organizationId,
              "name": this.emailConfigAccount.name,
              "description": this.emailConfigAccount.description,
              "configJSONSchema": "",
              "configJSONValue": "",
              "objectId": this.emailConfigAccount.objectId,
              "levelId": this.emailConfigAccount.levelId,
              "levelRecordId": this.emailConfigAccount.configurationDetails[0].levelRecordId,
              "categoryId": this.emailConfigAccount.categoryId,
              "statusId": Status.Active,
              "typeId": this.emailConfigAccount.typeId
            }
            this.accountDataTemp.id = this.accountEmail.length + 1;
            this.accountDataTemp.code = 'other';
            this.accountEmail.push(this.accountDataTemp);
            this.configTemp.configJSONValue = JSON.stringify(this.accountEmail);

            this.service.updateConfiguration(this.configTemp).then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Email Added Successfully...' });
              this.reLoadConfigurations.emit();
              this.displayAddAccountData = false;
              this.formSubmitted = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'account phone') {
          let lowerAccountNames = [];
          for (let s of this.accountPhone) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.configTemp = {
              "id": this.phoneConfigAccount.id,
              "createdSource": this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              "updatedBy": this.app.user.organizationId,
              "createdDate": new Date().toISOString(),
              "updatedDate": new Date().toISOString(),
              "organizationId": this.phoneConfigAccount.organizationId,
              "name": this.phoneConfigAccount.name,
              "description": this.phoneConfigAccount.description,
              "configJSONSchema": "",
              "configJSONValue": "",
              "objectId": this.phoneConfigAccount.objectId,
              "levelId": this.phoneConfigAccount.levelId,
              "levelRecordId": this.phoneConfigAccount.configurationDetails[0].levelRecordId,
              "categoryId": this.phoneConfigAccount.categoryId,
              "statusId": Status.Active,
              "typeId": this.phoneConfigAccount.typeId
            }
            this.accountDataTemp.id = this.accountPhone.length + 1;
            this.accountDataTemp.code = 'other';
            this.accountPhone.push(this.accountDataTemp);
            this.configTemp.configJSONValue = JSON.stringify(this.accountPhone);

            this.service.updateConfiguration(this.configTemp).then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Phone Added Successfully...' });
              this.reLoadConfigurations.emit();
              this.displayAddAccountData = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'account social') {
          let lowerAccountNames = [];
          for (let s of this.accountSocial) {
            lowerAccountNames.push(s.name.toLowerCase())
          }
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.configTemp = {
              "id": this.socialConfigAccount.id,
              "createdSource": this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              "updatedBy": this.app.user.organizationId,
              "createdDate": new Date().toISOString(),
              "updatedDate": new Date().toISOString(),
              "organizationId": this.socialConfigAccount.organizationId,
              "name": this.socialConfigAccount.name,
              "description": this.socialConfigAccount.description,
              "configJSONSchema": "",
              "configJSONValue": "",
              "objectId": this.socialConfigAccount.objectId,
              "levelId": this.socialConfigAccount.levelId,
              "levelRecordId": this.socialConfigAccount.configurationDetails[0].levelRecordId,
              "categoryId": this.socialConfigAccount.categoryId,
              "statusId": Status.Active,
              "typeId": this.socialConfigAccount.typeId
            }
            this.accountDataTemp.id = this.accountSocial.length + 1;
            this.accountDataTemp.code = 'other';
            this.accountSocial.push(this.accountDataTemp);
            this.configTemp.configJSONValue = JSON.stringify(this.accountSocial);

            this.service.updateConfiguration(this.configTemp).then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Social Profile Added Successfully...' });
              this.reLoadConfigurations.emit();
              this.displayAddAccountData = false;
              this.formSubmitted = false;
            });
          }
        }
        else if (this.selectedAccountDataType.code == 'AccountActivatedReason' || this.selectedAccountDataType.code == 'AccountInactivatedReason') {
          this.addActiveInactiveReason(true);
        }
        else if (this.selectedAccountDataType.code == 'address type') {
          this.addAddressType();
        }
        else if (this.selectedAccountDataType.code == 'address class') {
          this.addAddressClass();
        }
        else if (this.selectedAccountDataType.code == 'currency') {
          this.addCurrency();
        }
        else if(this.selectedAccountDataType.code == 'tags'){
         if (this.accountDataTemp.name.trim().length <= 0) {
           this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please write a valid tag name' });
             return;
         } else if(!this.accountDataTemp?.color){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select the tag color' });
            return;
          } else {
           this.addTags();
         }

        }
      }
      else if (this.showEditFieldDataArea) {
        if (this.accountTypeId == 0) {
          let lowerAccountNames = [];
          /* for (let s of this.accountType) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.accountType.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditAccountType(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadAccountTypes();
              this.displayAddAccountData = false;
              this.formSubmitted = false;
              this.invalidData = false;
            });
          }
        } else if (this.accountTypeId == 1) {
          let lowerAccountNames = [];
          /* for (let s of this.accountSource) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.accountSource.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditAccountSource(this.accountDataTemp)
              .then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                this.loadAccountSources();
                this.displayAddAccountData = false;
                this.invalidData = false;
              })
              .catch(err => {
                this.invalidData = false;
                const detail = err.status === 422 ? err.error : err.error.Message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail
                });
              });
          }
        } else if (this.accountTypeId == 2) {
          let lowerAccountNames = [];
          /* for (let s of this.ratings) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.ratings.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditRating(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadRatings();
              this.displayAddAccountData = false;
              this.formSubmitted = false;
              this.invalidData = false;
            });
          }
        } else if (this.accountTypeId == 3) {
          let lowerAccountNames = [];
          /*  for (let s of this.timeZoneList) {
             lowerAccountNames.push(s.name.toLowerCase())
           } */
          this.timeZoneList.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditTimezone(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadTimeZoneList();
              this.displayAddAccountData = false;
              this.formSubmitted = false;
              this.invalidData = false;
            });
          }
        } else if (this.accountTypeId == 4) {
          let lowerAccountNames = [];
          /* for (let s of this.employeesCounts) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.employeesCounts.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditEmployeesNo(this.accountDataTemp)
              .then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                this.loadEmployeeCountList()
                this.displayAddAccountData = false;
                this.invalidData = false;
              })
              .catch(err => {
                this.invalidData = false;
                const detail = err.status === 422 ? err.error : err.error.Message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail
                });
              });
          }
        } else if (this.accountTypeId == 5) {
          let lowerAccountNames = [];
          /* for (let s of this.revenue) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.revenue.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditRevenue(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadRevenuList();
              this.displayAddAccountData = false;
              this.invalidData = false;
            })
              .catch(err => {
                this.invalidData = false;
                const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail
                });
              });
          }
        } else if (this.accountTypeId == 6) {
          let lowerAccountNames = [];
          /* for (let s of this.ownerships) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.ownerships.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditOwnership(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadOwnerShipList();
              this.displayAddAccountData = false;
              this.invalidData = false;
            })
              .catch(err => {
                this.invalidData = false;
                const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail
                });
              });
          }
        } else if (this.accountTypeId == 7) {
          let lowerAccountNames = [];
          /* for (let s of this.industries) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.industries.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });

          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
            this.service.EditIndustry(this.accountDataTemp).then(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
              this.loadIndustries();
              this.displayAddAccountData = false;
              this.formSubmitted = false;
              this.invalidData = false;
            })
              .catch(err => {
                this.invalidData = false;
                const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail
                });
              });
          }
        } else if (this.accountTypeId == 8) {
          let lowerAccountNames = [];
          /* for (let s of this.accountEmail) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.accountEmail.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.configTemp = {
              "id": this.emailConfigAccount.id,
              "createdSource": this.emailConfigAccount.createdSource,
              updatedSource: this.app.userIP,
              createdBy: this.emailConfigAccount.createdBy,
              "updatedBy": this.app.user.organizationId,
              "createdDate": this.emailConfigAccount.createdDate,
              "updatedDate": new Date().toISOString(),
              "organizationId": this.emailConfigAccount.organizationId,
              "name": this.emailConfigAccount.name,
              "description": this.emailConfigAccount.description,
              "configJSONSchema": "",
              "configJSONValue": "",
              "objectId": this.emailConfigAccount.objectId,
              "levelId": this.emailConfigAccount.levelId,
              "levelRecordId": this.emailConfigAccount.configurationDetails[0].levelRecordId,
              "categoryId": this.emailConfigAccount.categoryId,
              "statusId": Status.Active,
              "typeId": this.emailConfigAccount.typeId
            }
            let arr = [];
            for (let s of this.accountEmail) {
              if (s.id == this.accountDataTemp.id) {
                s = JSON.parse(JSON.stringify(this.accountDataTemp));
                arr.push(s)
              } else {
                arr.push(s);
              }
            }
            this.accountEmail = JSON.parse(JSON.stringify(arr))
            this.configTemp.configJSONValue = JSON.stringify(this.accountEmail);

            this.service.updateConfiguration(this.configTemp).then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Email updated Successfully...' });
              this.reLoadConfigurations.emit({});
              this.formSubmitted = false;
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        } else if (this.accountTypeId == 9) {
          let lowerAccountNames = [];
          /* for (let s of this.accountPhone) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.accountPhone.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.configTemp = {
              "id": this.phoneConfigAccount.id,
              "createdSource": this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              "updatedBy": this.app.user.organizationId,
              "createdDate": new Date().toISOString(),
              "updatedDate": new Date().toISOString(),
              "organizationId": this.phoneConfigAccount.organizationId,
              "name": this.phoneConfigAccount.name,
              "description": this.phoneConfigAccount.description,
              "configJSONSchema": "",
              "configJSONValue": "",
              "objectId": this.phoneConfigAccount.objectId,
              "levelId": this.phoneConfigAccount.levelId,
              "levelRecordId": this.phoneConfigAccount.configurationDetails[0].levelRecordId,
              "categoryId": this.phoneConfigAccount.categoryId,
              "statusId": 1,
              "typeId": this.phoneConfigAccount.typeId
            }
            let arr = [];
            for (let s of this.accountPhone) {
              if (s.id == this.accountDataTemp.id) {
                s = JSON.parse(JSON.stringify(this.accountDataTemp));
                arr.push(s)
              } else {
                arr.push(s);
              }
            }
            this.accountPhone = JSON.parse(JSON.stringify(arr))
            this.configTemp.configJSONValue = JSON.stringify(this.accountPhone);

            this.service.updateConfiguration(this.configTemp).then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Phone Successfully...' });
              this.reLoadConfigurations.emit();
              this.formSubmitted = false;
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        } else if (this.accountTypeId == 10) {
          let lowerAccountNames = [];
          /* for (let s of this.accountSocial) {
            lowerAccountNames.push(s.name.toLowerCase())
          } */
          this.accountSocial.forEach(el => {
            if (el.id != this.accountDataTemp.id) {
              lowerAccountNames.push(el.name.toLowerCase())
            }
          });
          if (lowerAccountNames.indexOf(this.accountDataTemp.name.toLowerCase()) > -1) {
            this.invalidData = true;
          } else {
            this.configTemp = {
              "id": this.socialConfigAccount.id,
              createdSource: this.socialConfigAccount.createdSource,
              updatedSource: this.app.userIP,
              createdBy: this.socialConfigAccount.createdBy,
              "updatedBy": this.app.user.organizationId,
              "createdDate": this.socialConfigAccount.createdDate,
              "updatedDate": new Date().toISOString(),
              "organizationId": this.socialConfigAccount.organizationId,
              "name": this.socialConfigAccount.name,
              "description": this.socialConfigAccount.description,
              "configJSONSchema": "",
              "configJSONValue": "",
              "objectId": this.socialConfigAccount.objectId,
              "levelId": this.socialConfigAccount.levelId,
              "levelRecordId": this.socialConfigAccount.configurationDetails[0].levelRecordId,
              "categoryId": this.socialConfigAccount.categoryId,
              "statusId": Status.Active,
              "typeId": this.socialConfigAccount.typeId
            }
            let arr = [];
            for (let s of this.accountSocial) {
              if (s.id == this.accountDataTemp.id) {
                s = JSON.parse(JSON.stringify(this.accountDataTemp));
                arr.push(s)
              } else {
                arr.push(s);
              }
            }
            this.accountSocial = JSON.parse(JSON.stringify(arr))
            this.configTemp.configJSONValue = JSON.stringify(this.accountSocial);

            this.service.updateConfiguration(this.configTemp).then(stages => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Account Social Profile Updated Successfully...' });
              this.reLoadConfigurations.emit();
              this.formSubmitted = false;
              this.displayAddAccountData = false;
              this.invalidData = false;
            });
          }
        } else if (this.accountTypeId == 11 || this.accountTypeId == 12) {
          this.updateActiveInactiveReason();
        } else if (this.accountTypeId == 13) {
          this.updateAddressType();
        } else if (this.accountTypeId == 14) {
          this.updateAddressClass();
        } else if (this.accountTypeId == 15) {
          this.updateCurrency();
        }
      }
    }
  }

  checkValidationForFieldData() {
    let showError = false;
    if ((this.showAddFieldDataArea && !this.selectedAccountDataType) || !this.accountDataTemp.name) {
      showError = true;
    }
    return showError;
  }

  showEditAccountData(c, s) {
    this.accountDataTemp = JSON.parse(JSON.stringify(c));
    this.accountDataTemp['isActive'] = this.accountDataTemp.statusId == 1;

    if ([3, 8, 9, 10].includes(s.id)) {
      this.showActiveBtn = false;
    } else {
      this.showActiveBtn = true;
    }

    this.accountTypeId = s.id;
    this.formSubmitted = false;
    this.addEditAccountHeader = this.fieldTranslate.EditFieldDataHeader;
    this.displayAddAccountData = true;
    this.showAddFieldDataArea = false;
    this.showEditFieldDataArea = true;
  }

  delAccountType(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.AccountTypeDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteAccountType(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadAccountTypes();
        }).catch(() => {
          //this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  delAccountSource(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.AccountScourceDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteAccountSource(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadAccountSources();
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error.Message });
        });
      }
    });
  }

  delRating(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.RatingDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteRating(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quality Deleted Successfully...' });
          this.loadRatings();
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error.Message });
        });
      },
      reject: () => {
      }
    });
  }

  delTimezone(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.TimezoneDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteTimezone(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadTimeZoneList()
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  delEmployeesNo(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.NumOfEmployeeDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: (reason) => {
        this.service.deleteEmployeesNo(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadEmployeeCountList();
        }).catch((err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
        });
      }
    });
  }

  delRevenue(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.EstimatedAnnualRevenueDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteRevenue(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadRevenuList()
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error });
        });
      }
    });
  }

  delOwnership(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.OwnershipTypeDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteOwnership(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadOwnerShipList();
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error });
        });
      }
    });
  }

  delIndustry(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: this.fieldTranslate.IndustryDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteIndustry(c.id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
          this.loadIndustries()
        }).catch((reason) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: reason.error });
        });
      }
    });
  }

  delAccountEmail(i) {
    this.confirmationService.confirm({
      message: this.fieldTranslate.AccountEmailDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.emailConfigAccount.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.emailConfigAccount.organizationId,
          "name": this.emailConfigAccount.name,
          "description": this.emailConfigAccount.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.emailConfigAccount.objectId,
          "levelId": this.emailConfigAccount.levelId,
          "levelRecordId": this.emailConfigAccount.configurationDetails[0].levelRecordId,
          "categoryId": this.emailConfigAccount.categoryId,
          "statusId": 1,
          "typeId": this.emailConfigAccount.typeId
        }
        this.accountEmail.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.accountEmail);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Account Email Type Successfully...' });
          this.reLoadConfigurations.emit();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  delAccountPhone(i) {
    this.confirmationService.confirm({
      message: this.fieldTranslate.AccountPhoneDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.phoneConfigAccount.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.phoneConfigAccount.organizationId,
          "name": this.phoneConfigAccount.name,
          "description": this.phoneConfigAccount.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.phoneConfigAccount.objectId,
          "levelId": this.phoneConfigAccount.levelId,
          "levelRecordId": this.phoneConfigAccount.configurationDetails[0].levelRecordId,
          "categoryId": this.phoneConfigAccount.categoryId,
          "statusId": 1,
          "typeId": this.phoneConfigAccount.typeId
        }
        this.accountPhone.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.accountPhone);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Account Phone Type Successfully...' });
          this.reLoadConfigurations.emit();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  delAccountSocial(i) {
    this.confirmationService.confirm({
      message: this.fieldTranslate.AccountSocialProfileDeleteConfMsg,
      header: this.fieldTranslate.DeleteConfirmationHeader,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.configTemp = {
          "id": this.socialConfigAccount.id,
          "createdSource": this.app.userIP,
          "updatedSource": this.app.userIP,
          createdBy: this.app.user.userId,
          "updatedBy": this.app.user.organizationId,
          "createdDate": new Date().toISOString(),
          "updatedDate": new Date().toISOString(),
          "organizationId": this.socialConfigAccount.organizationId,
          "name": this.socialConfigAccount.name,
          "description": this.socialConfigAccount.description,
          "configJSONSchema": "",
          "configJSONValue": "",
          "objectId": this.socialConfigAccount.objectId,
          "levelId": this.socialConfigAccount.levelId,
          "levelRecordId": this.socialConfigAccount.configurationDetails[0].levelRecordId,
          "categoryId": this.socialConfigAccount.categoryId,
          "statusId": 1,
          "typeId": this.socialConfigAccount.typeId
        }
        this.accountSocial.splice(i, 1);
        this.configTemp.configJSONValue = JSON.stringify(this.accountSocial);

        this.service.updateConfiguration(this.configTemp).then(stages => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Social Profile Type Successfully...' });
          this.reLoadConfigurations.emit();
        }).catch(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  addAddressType() {
    let lowerOppNames = [];

    for (let s of this.addressTypes) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let addData = {
        ...this.accountDataTemp,
        groupId: TypeGroupIds.AddressTypeCoreAPI
      };

      this.service.addAddressType(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address Type Added Successfully...' });
        this.loadAddressTypes(true);
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  updateAddressType() {
    let lowerOppNames = [];

    const index = this.addressTypes.findIndex(s => s.id == this.accountDataTemp.id);

    this.addressTypes.splice(index, 1);

    for (let s of this.addressTypes) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let updateData = { ...this.accountDataTemp, groupId: TypeGroupIds.AddressTypeCoreAPI };
      updateData.statusId = updateData.isActive ? 1 : 2;
      this.service.updateAddressType(updateData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address Type Updated Successfully...' });
        this.loadAddressTypes();
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  deleteAddressType(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to delete this address type?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteAddressType(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address type deleted successfully...' });
          this.loadAddressTypes();
        }, () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  addAddressClass() {
    let lowerOppNames = [];

    for (let s of this.addressClasses) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let addData = {
        ...this.accountDataTemp,
        groupId: TypeGroupIds.AddressClassCoreAPI
      };

      this.service.addAddressClass(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address Class Added Successfully...' });
        this.loadAddressClasses(true);
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  updateAddressClass() {
    let lowerOppNames = [];

    const index = this.addressClasses.findIndex(s => s.id == this.accountDataTemp.id);

    this.addressClasses.splice(index, 1);

    for (let s of this.addressClasses) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let updateData = { ...this.accountDataTemp, groupId: TypeGroupIds.AddressClassCoreAPI };
      updateData.statusId = updateData.isActive ? 1 : 2;
      this.service.updateAddressClass(updateData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address Class Updated Successfully...' });
        this.loadAddressClasses();
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  deleteAddressClass(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to delete this address class?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteAddressClass(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address class deleted successfully...' });
          this.loadAddressClasses();
        }, () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  addCurrency() {
    let lowerOppNames = [];

    for (let s of this.currencies) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let addData = {
        ...this.accountDataTemp,
      };

      this.service.addCurrency(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Currency Added Successfully...' });
        this.loadCurrencies(true);
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while saving currency...'
        });
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  updateCurrency() {
    let lowerOppNames = [];

    const index = this.currencies.findIndex(s => s.id == this.accountDataTemp.id);

    this.currencies.splice(index, 1);

    for (let s of this.currencies) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (!this.accountDataTemp.isActive) {
      this.accountDataTemp.statusId = 2;
    }

    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let updateData = { ...this.accountDataTemp };
      this.service.updateCurrency(updateData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Currency Updated Successfully...' });
        this.loadCurrencies();
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, (err) => {
        this.displayAddAccountData = false;
        this.invalidData = false;
        const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail
        });
      });
    }
  }

  deleteCurrency(c) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to delete this currency?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.service.deleteCurrency(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Currency deleted successfully...' });
          this.loadCurrencies();
        }, () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }

  addActiveInactiveReason(fromAdd) {
    let lowerOppNames = [];

    for (let s of (this.selectedAccountDataType.code == 'AccountActivatedReason' ? this.activeReason : this.inactiveReason)) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }
    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      let addData = {
        ...this.accountDataTemp,
        groupId: (this.selectedAccountDataType.code == 'AccountActivatedReason' ? this.activeId : this.inactiveId)
      };

      this.accountService.addActiveInactiveReason(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Added Successfully...' });
        this.getActiveInactiveReason(this.selectedAccountDataType.code, fromAdd);
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  updateActiveInactiveReason() {
    let lowerOppNames = [];

    const index = this.accountTypeId == 11 ? this.activeReason.findIndex(s => s.id == this.accountDataTemp.id) :
      this.inactiveReason.findIndex(s => s.id == this.accountDataTemp.id);

    if (this.accountTypeId == 11) {
      this.activeReason.splice(index, 1);
    } else {
      this.inactiveReason.splice(index, 1);
    }

    for (let s of (this.accountTypeId == 11 ? this.activeReason : this.inactiveReason)) {
      lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
    }

    if (lowerOppNames.indexOf(this.accountDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
      this.invalidData = true;
    } else {
      this.accountDataTemp.statusId = this.accountDataTemp.isActive ? 1 : 2;
      let addData = { ...this.accountDataTemp, groupId: this.accountTypeId == 11 ? this.activeId : this.inactiveId };
      this.accountService.updateActiveInactiveReason(addData).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Updated Successfully...' });
        this.getActiveInactiveReason(this.accountTypeId == 11 ? 'AccountActivatedReason' : 'AccountInactivatedReason');
        this.displayAddAccountData = false;
        this.invalidData = false;
      }, () => {
        this.displayAddAccountData = false;
        this.invalidData = false;
      });
    }
  }

  getActiveInactiveReason(groupName: string, fromAdd?): void {
    this.appMainService.isShowSpinner('getActiveInActiveReasons');

    this.accountService.getActiveInactiveDataByName(groupName).subscribe(
      dataName => {
        this.appMainService.isHideSpinner('getActiveInActiveReasons');
        dataName &&
          this.accountService.getActiveInactiveReasons(dataName.id).subscribe(
            res => {
              if (groupName == 'AccountActivatedReason') {
                this.activeId = dataName.id;
                this.activeReason = res ? res : [];
                this.activeReason.sort((a, b) => a.name.localeCompare(b.name));

                if (fromAdd) {
                  this.copiedList = JSON.parse(JSON.stringify(this.activeReason));
                }
              } else {
                this.inactiveId = dataName.id;
                this.inactiveReason = res ? res : [];
                this.inactiveReason.sort((a, b) => a.name.localeCompare(b.name));

                if (fromAdd) {
                  this.copiedList = JSON.parse(JSON.stringify(this.inactiveReason));
                }
              }
            },
            () => {
              this.appMainService.isHideSpinner('getActiveInActiveReasons');
            });
      },
      () => {
        this.appMainService.isHideSpinner('getActiveInActiveReasons');
      })
  }

  _updateDefaultData(updateData) {
    this.appMainService.isShowSpinner('updateChannel')
    this.accountService.updateActiveInactiveReason(updateData).subscribe(stages => {
      this.appMainService.isHideSpinner('updateChannel')
    }, () => {
      this.appMainService.isHideSpinner('updateChannel')
    });
  }

  openAccordion(event) {
    switch (event.index) {
      case 0: {
        this.copiedList = JSON.parse(JSON.stringify(this.accountType));
        break;
      }
      case 1: {
        this.copiedList = JSON.parse(JSON.stringify(this.accountSource));
        break;
      }
      case 2: {
        this.copiedList = JSON.parse(JSON.stringify(this.ratings));
        break;
      }
      case 4: {
        this.copiedList = JSON.parse(JSON.stringify(this.employeesCounts));
        break;
      }
      case 5: {
        this.copiedList = JSON.parse(JSON.stringify(this.revenue));
        break;
      }
      case 6: {
        this.copiedList = JSON.parse(JSON.stringify(this.ownerships));
        break;
      }
      case 7: {
        this.copiedList = JSON.parse(JSON.stringify(this.industries));
        break;
      }
      case 13: {
        this.copiedList = JSON.parse(JSON.stringify(this.addressTypes));
        break;
      }
      case 14: {
        this.copiedList = JSON.parse(JSON.stringify(this.addressClasses));
        break;
      }
      case 15: {
        this.copiedList = JSON.parse(JSON.stringify(this.currencies));
        break;
      }
    }
  }

  makeAccountTypeDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.accountType.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultAccountType(element);
      }
    });

    this.appMainService.isShowSpinner('makeAccountTypeDefault');

    this.service.EditAccountType(data).then(() => {
      this.appMainService.isHideSpinner('makeAccountTypeDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadAccountTypes();
    }, () => {
      this.appMainService.isHideSpinner('makeAccountTypeDefault');
    });
  }

  updateDefaultAccountType(updateData) {
    this.appMainService.isShowSpinner('updateDefaultAccountType');
    this.service.EditAccountType(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultAccountType');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultAccountType');
    });
  }

  makeAccountSourceDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;
    // console.log(currentData);

    this.accountSource.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultAccountSource(element);
      }
    });

    this.appMainService.isShowSpinner('makeAccountSourceDefault');

    this.service.EditAccountSource(data).then(() => {
      this.appMainService.isHideSpinner('makeAccountSourceDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadAccountSources();
    }, () => {
      this.appMainService.isHideSpinner('makeAccountSourceDefault');
    });
  }

  updateDefaultAccountSource(updateData) {
    this.appMainService.isShowSpinner('updateDefaultAccountSource');
    this.service.EditAccountSource(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultAccountSource');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultAccountSource');
    });
  }

  makeRatingDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.ratings.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultRating(element);
      }
    });

    this.appMainService.isShowSpinner('makeRatingDefault');

    this.service.EditRating(data).then(() => {
      this.appMainService.isHideSpinner('makeRatingDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadRatings();
    }, () => {
      this.appMainService.isHideSpinner('makeRatingDefault');
    });
  }

  updateDefaultRating(updateData) {
    this.appMainService.isShowSpinner('updateDefaultRating');
    this.service.EditRating(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultRating');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultRating');
    });
  }

  makeEmployeesCountDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.employeesCounts.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultEmployeesCount(element);
      }
    });

    this.appMainService.isShowSpinner('makeEmployeesCountDefault');

    this.service.EditEmployeesNo(data).then(() => {
      this.appMainService.isHideSpinner('makeEmployeesCountDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadEmployeeCountList();
    }, () => {
      this.appMainService.isHideSpinner('makeEmployeesCountDefault');
    });
  }

  updateDefaultEmployeesCount(updateData) {
    this.appMainService.isShowSpinner('updateDefaultEmployeesCount');
    this.service.EditEmployeesNo(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultEmployeesCount');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultEmployeesCount');
    });
  }

  makeRevenueDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.revenue.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultRevenue(element);
      }
    });

    this.appMainService.isShowSpinner('makeRevenueDefault');

    this.service.EditRevenue(data).then(() => {
      this.appMainService.isHideSpinner('makeRevenueDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadRevenuList();
    }, () => {
      this.appMainService.isHideSpinner('makeRevenueDefault');
    });
  }

  updateDefaultRevenue(updateData) {
    this.appMainService.isShowSpinner('updateDefaultRevenue');
    this.service.EditRevenue(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultRevenue');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultRevenue');
    });
  }

  makeOwnershipDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.ownerships.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultOwnership(element);
      }
    });

    this.appMainService.isShowSpinner('makeOwnershipDefault');

    this.service.EditOwnership(data).then(() => {
      this.appMainService.isHideSpinner('makeOwnershipDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadOwnerShipList();
    }, () => {
      this.appMainService.isHideSpinner('makeOwnershipDefault');
    });
  }

  updateDefaultOwnership(updateData) {
    this.appMainService.isShowSpinner('updateDefaultOwnership');
    this.service.EditOwnership(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultOwnership');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultOwnership');
    });
  }

  makeIndustryDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.industries.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultIndustry(element);
      }
    });

    this.appMainService.isShowSpinner('makeIndustryDefault');

    this.service.EditIndustry(data).then(() => {
      this.appMainService.isHideSpinner('makeIndustryDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadIndustries();
    }, () => {
      this.appMainService.isHideSpinner('makeIndustryDefault');
    });
  }

  updateDefaultIndustry(updateData) {
    this.appMainService.isShowSpinner('updateDefaultIndustry');
    this.service.EditIndustry(updateData).then(() => {
      this.appMainService.isHideSpinner('updateDefaultIndustry');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultIndustry');
    });
  }

  makeAddressTypeDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.addressTypes.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultAddressType(element);
      }
    });

    this.appMainService.isShowSpinner('makeAddressTypeDefault');

    this.service.updateAddressType(data).toPromise().then(() => {
      this.appMainService.isHideSpinner('makeAddressTypeDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadAddressTypes();
    }, () => {
      this.appMainService.isHideSpinner('makeAddressTypeDefault');
    });
  }

  updateDefaultAddressType(updateData) {
    this.appMainService.isShowSpinner('updateDefaultAddressType');
    this.service.updateAddressType(updateData).toPromise().then(() => {
      this.appMainService.isHideSpinner('updateDefaultAddressType');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultAddressType');
    });
  }

  makeAddressClassDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.addressClasses.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultAddressClass(element);
      }
    });

    this.appMainService.isShowSpinner('makeAddressClassDefault');

    this.service.updateAddressClass(data).toPromise().then(() => {
      this.appMainService.isHideSpinner('makeAddressClassDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadAddressClasses();
    }, () => {
      this.appMainService.isHideSpinner('makeAddressClassDefault');
    });
  }

  updateDefaultAddressClass(updateData) {
    this.appMainService.isShowSpinner('updateDefaultAddressClass');
    this.service.updateAddressClass(updateData).toPromise().then(() => {
      this.appMainService.isHideSpinner('updateDefaultAddressClass');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultAddressClass');
    });
  }

  makeCurrencyDefault(data) {
    // const currentData = this.copiedList.filter(el => el.id === data.id)[0];
    // currentData.isDefault = !currentData.isDefault;

    this.currencies.forEach(element => {
      if (element.id != data.id && element.isDefault === true) {
        element.isDefault = false;
        this.updateDefaultCurrency(element);
      }
    });

    this.appMainService.isShowSpinner('makeCurrencyDefault');

    this.service.updateCurrency(data).toPromise().then(() => {
      this.appMainService.isHideSpinner('makeCurrencyDefault');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.loadCurrencies();
    }, () => {
      this.appMainService.isHideSpinner('makeCurrencyDefault');
    });
  }

  updateDefaultCurrency(updateData) {
    this.appMainService.isShowSpinner('updateDefaultCurrency');
    this.service.updateCurrency(updateData).toPromise().then(() => {
      this.appMainService.isHideSpinner('updateDefaultCurrency');
    }, () => {
      this.appMainService.isHideSpinner('updateDefaultCurrency');
    });
  }

  makeActiveInactiveDefault(data) {
    // let updateData = data;

    if (data.groupId == this.activeId) {
      this.activeReason.forEach(element => {
        if (element.id != data.id && element.isDefault === true) {
          element.isDefault = false;
          this._updateDefaultData(element);
        }
      });
    } else {
      this.inactiveReason.forEach(element => {
        if (element.id != data.id && element.isDefault === true) {
          element.isDefault = false;
          this._updateDefaultData(element);
        }
      });
    }

    this.appMainService.isShowSpinner('updateChannel');

    this.accountService.updateActiveInactiveReason(data).subscribe(() => {
      this.appMainService.isHideSpinner('updateChannel');
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
      this.getActiveInactiveReason(data.groupId == this.activeId ? 'AccountActivatedReason' : 'AccountInactivatedReason');
    }, () => {
      this.appMainService.isHideSpinner('updateChannel');
    });
  }

  deleteActiveInactiveReason(c, s) {
    if (c.isDefault) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to delete this Reason?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.accountService.deleteActiveInactiveReason(c.id).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Deleted Successfully...' });
          if (s.id == 11) {
            this.getActiveInactiveReason('AccountActivatedReason');
          } else {
            this.getActiveInactiveReason('AccountInactivatedReason');
          }
        }, () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
        });
      }
    });
  }


  loadTages(){
    this.appMainService.isShowSpinner('loadTags');
    this.fieldService.getAllTags().subscribe({
      next:(tags)=>{
        this.tagList = tags;
        this.appMainService.isHideSpinner('loadTags');
      },
      error:(error:HttpErrorResponse)=>{
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
        this.appMainService.isHideSpinner('loadTags');
      }
    })
  }

  addTags(){
    this.appMainService.isShowSpinner('createTags');
    let newTag:{id:number,name:string,color:string} = {
      id:0,
      name:this.accountDataTemp?.name.trim(),
      color:this.accountDataTemp?.color
    }

    this.fieldService.addTags(newTag)
      .pipe(
          tap((data)=>{
            if(data == null){
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Duplicate tag names are not allowed.' });
              this.appMainService.isHideSpinner('createTags');
            }else{
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
              this.loadTages();
              this.displayAddAccountData = false;
              this.appMainService.isHideSpinner('createTags');
            }
          }),
        catchError(() => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
          this.appMainService.isHideSpinner('createTags');
          return of(null)
        }),
      )
      .subscribe();
  }

  showEditTag(tag){
    this.displayEditTag = true;
    this.tempTag = {
      id: tag?.id,
      name: tag?.name,
      color: tag?.color,
      statusId: tag?.statusId,
      isActive: tag?.statusId == 1 ? true : false,
    }
  }

  saveTag(){
    this.appMainService.isShowSpinner('updateTags');
    let requestBody = {
      id: this.tempTag?.id,
      name: this.tempTag?.name.trim(),
      color: this.tempTag?.color,
      statusId: this.tempTag?.isActive ? 1 : 2,
    }
    this.fieldService.editTags(requestBody).subscribe({
      next:(data)=>{
        if(data == null){
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Duplicate tag names are not allowed.' });
        }else{
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tag is Successfully updated...' });
          this.displayEditTag = false;
          this.loadTages();
          this.appMainService.isHideSpinner('updateTags');
        }
        },
        error:(error:HttpErrorResponse)=>{
          // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
          this.appMainService.isHideSpinner('updateTags');
        }
    });
  }

  deleteTag(tag){
    this.confirmationService.confirm({
      message: 'Do you want to delete this Tag?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteTags');
        this.fieldService.deleteTags(tag?.id).subscribe({
          next:(data)=>{
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tag is Successfully deleted...' });
            this.loadTages();
            this.appMainService.isHideSpinner('deleteTags');
            },
            error:(error:HttpErrorResponse)=>{
              // TODO find why error message showing twitch
              // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred.' });
              this.appMainService.isHideSpinner('deleteTags');
            }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.ngUnsubscribe$.unsubscribe();
    }
  }
}
